import axios from 'axios';
import { LanguageObject } from '@/i18n';
import { Survey, SurveyGroup, SurveyParticipation } from './SurveyUtils';
import { OversightOrganization } from './OversightUtils';
import { Bookshelf } from './ResourceUtils';
import { NotificationAssoc } from './NotificationUtils';

interface TileOptions {
  title: LanguageObject;
}

interface TileAPIParams {
  surveygroup?: Partial<SurveyGroup>;
  survey?: Partial<Survey>;
  surveyparticipation?: Partial<SurveyParticipation>;
  oversight?: Partial<OversightOrganization>;
}

const convertparams = (params: TileAPIParams) => {
  return {
    surveygroupid: params.surveygroup?.id,
    surveyid: params.survey?.id,
    participationid: params.surveyparticipation?.id,
    oversightid: params.oversight?.id,
  };
};

/**
 * BOOKSHELF
 */
interface TileBookshelfOptions extends TileOptions {
  bookshelf: Partial<Bookshelf>;
}

/**
 * NOTIFICATIONS
 */
interface TileNotificationsOptions extends TileOptions {}

const getNotifications = async () => {
  const resp = await axios.get<NotificationAssoc[]>(
    '/dashboard/getNotifications.php'
  );
  return resp.data;
};

const markNotificationAsRead = async (id: number) => {
  const resp = await axios.get<any>('/dashboard/markNotificationAsRead.php', {
    params: { id: id },
  });
};

/**
 * SURVEY PROGRESS
 */
interface TileSurveyProgressOptions extends TileOptions {}
interface TileSurveyProgressResponse {
  sections: {
    name: LanguageObject;
    progress: number;
  }[];
  suborganizations: {
    name: LanguageObject;
    progress: number;
  }[];
}
const submissionstatus = async (params: TileAPIParams) => {
  const resp = await axios.get<any>('/dashboard/survey/getProgress.php', {
    params: convertparams(params),
  });

  const suborganizations =
    resp.data.suborganizations?.map((item: any) => ({
      name: item.suborg.name,
      progress: item.progress,
    })) || [];

  const sections =
    params.survey?.layout?.map((section) => ({
      name: section.name,
      progress: resp.data.sections.find(
        (item: any) => item.sectionkey === section.key
      )?.progress,
    })) || [];

  return {
    sections: sections,
    suborganizations: suborganizations,
  } as TileSurveyProgressResponse;
};

export default {
  getNotifications,
  markNotificationAsRead,
  submissionstatus,
};

export {
  TileOptions,
  TileAPIParams,
  TileBookshelfOptions,
  TileNotificationsOptions,
  TileSurveyProgressOptions,
  TileSurveyProgressResponse,
};
